import { render, staticRenderFns } from "./NewsNode.vue?vue&type=template&id=cba0c582&scoped=true"
import script from "./NewsNode.vue?vue&type=script&lang=js"
export * from "./NewsNode.vue?vue&type=script&lang=js"
import style0 from "./NewsNode.vue?vue&type=style&index=0&id=cba0c582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_babel-core@6.26.3_css-loader@6.11.0_webpack@5.100_4xpmdqc3iaixeru4y6alscik5i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba0c582",
  null
  
)

export default component.exports